<script setup lang="ts">
const page = usePage().value;

const getAuthor = computed(() => {
  const author = page?.author;
  const author2 = page?.author2;

  const people = Array.isArray(page?.people) ? page.people : [];
  const guides = Array.isArray(page?.guides) ? page.guides : [];

  if (author2) {
    const match =
      guides.find((item) => item.name === author2) ??
      people.find((item) => item.name === author2);
    return match ? [match] : [];
  }

  if (author) {
    const match =
      people.find((item) => item.name === author) ??
      guides.find((item) => item.name === author);
    return match ? [match] : [];
  }

  return [];
});
</script>

<template>
  <div v-for="(member, index) in getAuthor" :key="index" class="author">
    <h3>About the Author</h3>
    <div class="author-wrap">
      <div class="author-photo">
        <NuxtPicture
          v-if="member?.image"
          loading="lazy"
          :src="member?.image.url"
          :width="member?.image.width"
          :height="member?.image.height"
          :alt="member?.image.alt ?? undefined"
          sizes="sm:100vw md:50vw lg:300px"
        />
      </div>
      <div class="author-info">
        <NuxtLink to="/about/meet-the-team">
          <h3>{{ member?.name }}</h3>
        </NuxtLink>
        <p>{{ member?.job_title }}</p>
        <div class="author-description" v-html="member?.description"></div>
      </div>
    </div>
    <AppSVGBrandGraphic />
  </div>
</template>
